<script>
  import { getTableContext } from "./TableContext.js";

  export let style = "";
  export let colspan = 1;
  export let stickToRight = false;
  export let isResultEditButton = false;

  export let resultEditButtonOnClicked = undefined;

  const tableContext = getTableContext();


</script>

<td
  {colspan}
  {style}
  class:wide={$tableContext?.type === "wide"}
  class:stick-to-right={stickToRight}
>
  {#if isResultEditButton}
    <div class="button-wrapper">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="button-container" on:click={resultEditButtonOnClicked}>
        <img
        src="/assets/icons/icon_edit_results.svg"
        alt="Result Edit"
        class="icon-button"
      />
      </div>
    </div>
  {:else}
    <slot />
  {/if}
</td>

<style>
  td {
    border: 1px solid #d3d3d3;
    padding: 8px;
    white-space: pre-wrap;
    text-align: center;
    position: relative;
  }

  .wide {
    word-break: keep-all;
  }

  .stick-to-right {
    position: sticky;
    right: 0;
    background-color: white;
    z-index: 2;
    width: 100px;
  }

  .stick-to-right::before {
    content: "";
    position: absolute;
    top: 0;
    left: -1px;
    height: 100%;
    width: 1px;
    background-color: #d3d3d3;
    box-shadow: -8px 0 8px rgba(0, 0, 0, 0.15);
  }


  .button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 100%;
  }

  .button-container {
    width: 100%;
    height: 100%;
    max-width: 90%;
    max-height: 90%;
    border: 2px solid #28385d;
    border-radius: 8px;
    box-sizing: border-box;
    object-fit: contain;
    background-color: white;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .icon-button {
    max-width: 24px;
    max-height: 24px;
  }

  @media (max-width: 600px) {
    td {
      font-size: 0.875rem;
      padding: 6px;
    }
  }
</style>
